<template>
  <div class="wrapper flex-column align-center justify-center full-parent">
    <div class="bg-block">
      <img
        class="bg"
        draggable="false"
        src="https://mm2015.mamalaile.com.cn/e23dc831a7325962c6afdeba890d7ec6.png"
      />

      <div class="info-block flex-row">
        <div class="contact">
          <div class="title nowrap">联系我们</div>
          <div class="subtitle nowrap">CONTACT US</div>
          <div class="company nowrap">生活魔方（深圳）科技有限公司</div>
          <div class="company nowrap">咨询电话：</div>
          <img
            class="phone"
            src="https://mm2015.mamalaile.com.cn/a084c591d87c239e7f54e169f772315e.png"
          />
        </div>
        <div class="map-block">
          <div v-for="(item, index) of mapList" :key="index" class="map-item">
            <div class="name">{{ item.name }}</div>
            <div
              v-for="(aItem, aIndex) of item.address.split('#')"
              :key="aIndex"
              class="address"
            >
              {{ aItem }}
            </div>
            <button class="button pointer" @click="toMap(item.map)">
              <span>查看地图</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {
      mapList: [
        { name: '服务中心', address: '深圳市南山区凯德·公园一号C座13楼', map: 'https://map.baidu.com/poi/@12682979.545,2557670.67,19z?uid=95d8e437bdf5262781a12ee3&querytype=detailConInfo' },
        { name: '培训中心', address: '深圳市南山区凯德·公园一号C座13楼', map: 'https://map.baidu.com/poi/@12682979.545,2557670.67,19z?uid=95d8e437bdf5262781a12ee3&querytype=detailConInfo' },
      ]
    };
  },

  methods: {
    toMap(address: string) {
      window.open(address);
    },
  },
});
</script>

<style lang="less" scoped>
.wrapper {
  .bg-block {
    position: relative;

    .bg {
      width: 87.5vw;
    }

    .info-block {
      position: absolute;
      top: 28.02vw;
      left: 51.25vw;
      color: white;

      .contact {
        margin-right: 4vw;

        .title {
          font-size: 1.82vw;
          line-height: 2.5vw;
          font-family: @font-ab;
          margin-bottom: 0.26vw;
        }

        .subtitle {
          font-size: 1.04vw;
          line-height: 1.41vw;
          font-family: @font-ab;
          margin-bottom: 3.6vw;
        }

        .company {
          font-size: 0.73vw;
          color: white;
          line-height: 1.04vw;
          margin-bottom: 0.8vw;
        }

        .phoneTitle {
          font-size: 0.73vw;
          color: white;
          line-height: 1.04vw;
          margin-bottom: 1.2vw;
        }

        .phone {
          width: 9.27vw;
        }
      }

      .map-block {
        .map-item {
          margin-bottom: 2.86vw;

          .name {
            font-size: 1.04vw;
            line-height: 1.41vw;
            font-family: @font-ab;
            margin-bottom: 0.52vw;
          }

          .address {
            max-width: 20vw;
            font-size: 0.73vw;
            line-height: 1.04vw;
          }

          .button {
            @hr: 1.33vw;
            width: 4.53vw;
            height: @hr;
            font-size: 0.73vw;
            margin-top: 0.52vw;
            border-radius: @hr;
            text-align: center;
            border: solid white 1px;
            display: flex;
            align-items: center;
            justify-content: center;

            span {
              transform: translateY(-0.5px);
            }

            &:active {
              color: @color-primary;
              background-color: white;
            }
          }
        }
      }
    }
  }
}
</style>